import { DataAccess } from "../../../dataaccess/data.access";
import { AccessLevel } from "../../../pojo/Fls";
import { RoleRights } from "./role.rights";

/**
 * Individual contact grants scoped to an organization ({@code acct_cont_right.acct_id} as {@code orgId} in JSON).
 */
export class UserScopedAccessConfigService {
    public static async getContactOrgGrants(contId: number, orgId: number): Promise<AcctContRightGrant[]> {
        const q = DataAccess.params({ contId, orgId }, { sort: true });
        return await DataAccess.get<AcctContRightGrant[]>(`/organization/access/user.json${q ? `?${q}` : ""}`);
    }

    /** All individual grants on one organization. */
    public static async getOrgIndividualGrants(orgId: number): Promise<AcctContRightGrant[]> {
        const params = DataAccess.params({ orgId }, { sort: true });
        return await DataAccess.get<AcctContRightGrant[]>(
            `/organization/access/user.json${params ? `?${params}` : ""}`,
        );
    }

    public static async putContactOrgGrants(grants: AcctContRightGrantWrite[]): Promise<void> {
        await DataAccess.put(`/organization/access/user.json`, { grants });
    }

    public static async deleteContactOrgGrant(contId: number, orgId: number, rightName: string): Promise<void> {
        const q = DataAccess.params({ contId, orgId, rightName }, { sort: true });
        await DataAccess.delete(`/organization/access/user.json${q ? `?${q}` : ""}`);
    }

    /** Removes every individual grant for the contact on the organization. */
    public static async deleteAllContactOrgGrants(contId: number, orgId: number): Promise<void> {
        const params = DataAccess.params({ contId, orgId }, { sort: true });
        await DataAccess.delete(`/organization/access/user.json${params ? `?${params}` : ""}`);
    }
}

/** Row from GET — organization key is {@code orgId} (acct_id). */
export interface AcctContRightGrant {
    contId: number;
    orgId: number;
    rightName: RoleRights.RightDefinition["rightName"];
    accessLevel: AccessLevel;
}

/** PUT body */
export interface AcctContRightGrantWrite {
    contId: number;
    orgId: number;
    rightName: RoleRights.RightDefinition["rightName"];
    accessLevel: AccessLevel;
}
